import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";
import styled from "styled-components";

const HelpLayout = styled.div`
  .material-icons {
    vertical-align: middle;
    font-size: 1.1em;
  }
`;

const LatencyDPIHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  const doClose = () => setOpen(false);

  useEffect(() => {
    return actions.recv("open-help", function () {
      setOpen(true);
    });
  }, []);
  return open !== true ? null : (
    <Modal
      title="Internet latency per application"
      onClose={doClose}
      content={() => (
        <HelpLayout>
          <p>For each application, an histogram is provided with the distribution of the Internet latencies (RTT), measured from the BQN to the application servers. Next to the application label, the average (mean) value in milliseconds is included.</p>
          <p>The histogram divides the range of latency values in a number of bins (from 0 to 5ms, between 5ms and 10 ms, and so on). The value in each bin is the percentage of latency measurements falling on that bin interval. For example, 80% in the 25-30ms bin indicates that 80% of the measurements are between 25ms and 30ms.</p>
          <p>Click on an application label to go to the time evolution of its latency distribution, i.e. the percentage of samples in each bin at different times. In that case, the bins are between 0-10ms, 10ms and 20ms, etc. Bins are stacked so we can use the horizontal axis for the time variable.</p>
          <p>The latency measurements to include in the analysis can be adjusted using the selectors at the top of the page:</p>
          <ul>
            <li><i className="material-icons hyperlink-generic">date_range</i> Selects the time range of measurements to analyze (last 24 hours, last week, etc).</li>
            <li><i className="material-icons valign-icon">format_line_spacing</i> Selects the number of applications to display. The ones with higher volume consumption will be selected.</li>
            <li><i className="material-icons">call_split</i> Decides whether to use all latency measurements ("All UDRs", the default, which includes also measurements generated by monitoring policies) or consider only those generated automatically by the BQN ("Only auto UDR"), which excludes policy-generated measurements. This later option is used when monitor policies can introduce a bias in the general results.</li>
            <li><b>Access IP:</b> you can filter the latency results to include only traffic from certain subscriber(s). Subscribers can be identified by an IP address or a range or by its subscriber Id.</li>
            <li><b>Internet IP:</b> you can filter the latency results to include traffic coming only from certain Internet IP address or range.</li>
          </ul>
          <p>
            Click on <i className="material-icons valign-icon">refresh</i> icon
            to refresh information.
          </p>
          <p> Once the filter values has been set, click <code>Filter</code> button to update table.</p>
        </HelpLayout>
      )}
    />
  );
};
export default LatencyDPIHelpModal;
